import { Component, type ReactNode } from "react";
import { ErrorState } from "./Workspace.tsx";

/** 页面渲染失败时保留导航,用户仍能切换页面或主动重新加载。 */
export class ScreenBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } { return { failed: true }; }

  override render(): ReactNode {
    if (this.state.failed) return <ErrorState message="页面暂时无法显示。请重新加载，或从导航打开其他功能。" onRetry={() => window.location.reload()} />;
    return this.props.children;
  }
}
